export default "__VITE_ASSET__06d8fe96__"